
const Overlay = (props) => {
    return(
        <section className={"px-[2rem] notebook:px-[6rem] desktop:px-[10rem] full:px-[12rem] " + props.classes}>
            {props.children}
        </section>
    )
}

export  default Overlay